import React from 'react'
import { connect } from 'dva';
import { Button } from 'antd';
import style from './preview.less'
import tabbar from '../../../../../assets/teacherCare/tableH.png'

@connect(({ getPushRuless }) => ({
  ...getPushRuless
}))
class PreviewCom extends React.Component {

  onCancle = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'getPushRuless/upDate',
      payload: {
        show: false,
      }
    })
  }


  render () {
    const { data, show, content, schoolN } = this.props
    const { urlTow, id } = data || {}
    return (
      <div className={style.preview_root} style={{ display: show ? 'flex' : 'none' }}>
        <div className='preview-content'>
          <img src={tabbar} className='preview-one' alt="" />
          <div className='preview-box'>
            <img src={urlTow} alt="" />
          </div>
          <div className={id !== (2 || 7) ? 'preview-word-box' : 'preview-word-color'} style={{ color: (id == 1 || id == 3 || id == 5 || id == 6) ? "rgba(255, 255, 255, 0.9)" : 'rgba(83, 77, 67, 0.9)' }}>
            <p>
              {content.substr(0, 18)}
            </p>
            <p style={{ display: content.length > 18 ? 'block' : 'none' }}>
              {content.substr(18, 20)}
            </p>
            <p style={{ display: content.length > 38 ? 'block' : 'none' }}>
              {content.substr(38, 20)}
            </p>
          </div>
          <div className='preview-word-footer' style={{ color: (id == 1 || id == 3 || id == 5 || id == 6) ? "rgba(255, 255, 255, 0.9)" : 'rgba(83, 77, 67, 0.9)' }}>
            <span>{schoolN}</span>
            <span>[贺卡推送日期]</span>
          </div>
        </div>
        <Button onClick={this.onCancle}>关闭</Button>
      </div>
    )
  }

}

export default PreviewCom;